import styled from '@emotion/styled';

import type { ScrollMarginTopProps } from 'common/theme/system-utilities';
import { scrollMarginTop } from 'common/theme/system-utilities';
import { RESULTS_HEADING_ID } from '../constants';

const Anchor = styled.div<ScrollMarginTopProps>`
  ${scrollMarginTop}
`;

const ResultsHeadingAnchor = (props: ScrollMarginTopProps) => (
  <Anchor id={RESULTS_HEADING_ID} scrollMarginTop="sp_16" {...props} />
);

export default ResultsHeadingAnchor;
